import React, {useEffect, useState} from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import {Col, Row} from "react-bootstrap";
import "../../styles/common/login.scss";
import {useNavigate} from 'react-router-dom';
import {postLogin} from "../../../api/apiClient";
import SeoulSymbol from "../../../data/seoul-symbol.png";
import Nav from 'react-bootstrap/Nav';

const Login = () => {
  const [details, setDetails] = useState({
    username: "",
    password: ""
  });

  const [error, setError] = useState("");

  const navigate = useNavigate();

  const submitHandler = (e) => {
    e.preventDefault();
    Login(details).then(r => console.log(r));
  };

  useEffect(() => {
    if (localStorage.getItem('LOGIN_MSG') != null) {
      let errorMsg = localStorage.getItem('LOGIN_MSG');
      localStorage.removeItem('LOGIN_MSG');
      setError(errorMsg);
    }
  }, [])

  const Login = async (details) => {
    const res = await postLogin(details)
        .catch(error => setError("아이디 또는 비밀번호가 일치하지 않습니다."));

    console.log(res.data);

    if (res.data.success === true) {
      console.log('nav')
      navigate(`/ui/dash_platform`);
    }

    return res;
  };

  return (
      <div className={'login'}>
        <Container className={"login-container p-5"}>
          <>
            <Row className={"justify-content-center"}>
              <Col md={12}>
                <div className={"logo-container text-center mb-4"}>
                  <div className={"logo-contents"}>
                    {/*<Row className={"justify-content-center"}>*/}
                      {/*<Col md={1} className={""}>*/}

                      {/*</Col>*/}
                      {/*<Col md={5} className={"text-center"}>*/}
                      <h1 className={"logo-title fw-bold fs-5"}>
                        <img src={SeoulSymbol} alt={"서울시"} className={"logo-img me-2"}/>
                        서울특별시
                      </h1>
                      {/*</Col>*/}
                    {/*</Row>*/}
                    <Row>
                      <Col className={"mt-3"}>
                      <span className={"logo-title-sub fs-5"}>
                        화재 안전관리 플랫폼
                      </span>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>

              <Col md={10}>
                <Form
                    onSubmit={submitHandler}
                    className={"login-form"}
                    id={"loginForm"}
                >
                  <Row className={"justify-content-center"}>
                    <Col md={10}>
                      <Form.Group className="mb-4" controlId="formBasicId">
                        <Form.Control
                            type="text"
                            placeholder="아이디"
                            className={"form-control input-id"}
                            onChange={(e) => setDetails({...details, username: e.target.value})}
                            value={details.username || ''}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={10}>
                      <Form.Group className="mb-4" controlId="formBasicPassword">
                        <Form.Control
                            type="password"
                            placeholder="패스워드"
                            className={"form-control input-pw"}
                            onChange={(e) => setDetails({...details, password: e.target.value})}
                            value={details.password || ''}
                        />
                      </Form.Group>
                    </Col>
                    {error !== "" ? (
                        <Col md={12} className={"error text-center text-danger mb-4"}>
                          {error}
                        </Col>
                    ) : ("")}
                    <Col md={10} className={"text-center mb-5"}>
                      <Button type="submit" className={"login-btn m-0 rounded-3 w-100"}>
                        로그인
                      </Button>
                    </Col>

                  </Row>
                </Form>
              </Col>

              {/*<Col md={10}>
                <Row className={"justify-content-center text-center"}>
                  <Col>
                    <Nav.Link href="#">아이디 찾기</Nav.Link>
                  </Col>
                  <Col>
                    <Nav.Link href="/reset-pw">비밀번호 초기화</Nav.Link>
                  </Col>
                </Row>
              </Col>*/}

            </Row>
          </>
        </Container>
      </div>);
};

export default Login;
